import {useMutation, useQuery, useQueryClient} from "react-query";
import axios from "axios";
import {PagedSearchParams} from "@atiautomacao/ati-ui-library";
import {useSnackbar} from "notistack";


const apiUrl = "api/modBusDataTypes";

const fetchModBusDataType = async (pagedSearchParams: PagedSearchParams) => {
    try {
        return await axios
            .get(apiUrl + "/search", {
                params: pagedSearchParams ? pagedSearchParams.toURLSearchParams() : null
            })
            .then((res) => res.data);
    } catch (error) {
        console.error("Error fetching data:", error);
        return Promise.reject(error);
    }
};

export const ModBusDataTypeReactQuery = (pagedSearchParams: PagedSearchParams) => {
    return useQuery({
        queryKey: ["data", pagedSearchParams],
        queryFn: () => {
            return fetchModBusDataType(pagedSearchParams);
        }
    });
};

const saveModBusDataType = async (data: any) => {
    try {
        if(data.id){
            return await axios.put(`${apiUrl}`, data).then((res) => res.data);
        } else {
            return await axios.post(apiUrl, data).then((res) => res.data);
        }
    } catch (error) {
        console.error("Error saving data:", error);
        return Promise.reject(error);
    }
};

export const SaveModBusDataTypeReactQuery = () => {
    const { enqueueSnackbar } = useSnackbar();

    return useMutation({
        mutationFn: (data: any) => {
            return saveModBusDataType(data);
        },
        onSuccess: () => {
            enqueueSnackbar("ModBusDataType salvo com sucesso!", { variant: "success" });
        },
        onError: (error: any) => {
            const detail = error.response?.data?.title;
            if(detail === "Already exists") {
                enqueueSnackbar(`Erro ao salvar tipo de dado! Já tem um registro com o mesmo nome.`, { variant: "error" });
            } else {
                enqueueSnackbar(`Erro ao salvar tipo de dado: ${error.message}`, { variant: "error" });
            }
        }
    })
};

const deleteModBusDataType = async (id: number) => {
    try {
        return await axios.delete(`${apiUrl}/${id}`).then((res) => res.data);
    } catch (error) {
        console.error("Error fetching data:", error);
        return Promise.reject(error);
    }
};

export const DeleteModBusDataTypeReactQuery = (pagedSearchParams: PagedSearchParams) => {
    const { enqueueSnackbar } = useSnackbar();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: any) => {
            return deleteModBusDataType(data.id);
        },
        onSuccess: () => {
            enqueueSnackbar("Tipo de Dado excluído com sucesso!", { variant: "success" });
            if (pagedSearchParams) {
                queryClient.invalidateQueries(["data", pagedSearchParams]);
            }
        },
        onError: (error: any) => {
            enqueueSnackbar(`Erro ao excluir Tipo de Dado: ${error.message}`, { variant: "error" });
        }
    })
};

const fetchModBusDataTypeById = async (id: number) => {
    return await axios.get(`${apiUrl}/${id}`).then((res) => res.data);
};

export const FindModBusDataTypeByIdReactQuery = () => {
    const { enqueueSnackbar } = useSnackbar();
    return useMutation({
        mutationFn: (id: number) => {
            return fetchModBusDataTypeById(id);
        },
        onError: (error: any) => {
            enqueueSnackbar(`Erro ao carregar um ModBusDataType: ${error.message}`, { variant: "error" });
        }
    })
};